import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import Button from '../../common/Button';

const ContactCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
      <Container>
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Get Expert IT Support?
            </h2>
            
            <p className="text-lg text-blue-100 mb-8">
              Partner with Bytematic for reliable, efficient, and professional IT support services.
              Contact us today to discuss how we can help maintain and optimize your IT infrastructure.
            </p>
            
            <Button 
              to="/contact" 
              variant="secondary"
              size="lg"
              className="text-blue-700 hover:bg-green-500 hover:text-white"
            >
              Partner with Bytematic Today!
            </Button>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default ContactCTA;